/**
 * Curated UCUM-aligned unit list for Indian B2B/B2C commerce.
 * Grouped for readability; each entry: value = case-sensitive UCUM code (or common code),
 * label = friendly display. Extend as needed.
 */
export const UNITS = [
  // Count
  { value: "nos", label: "Numbers (nos)" }, { value: "pcs", label: "Pieces (pcs)" },
  { value: "ea", label: "Each (ea)" }, { value: "dozen", label: "Dozen" },
  { value: "pair", label: "Pair" }, { value: "set", label: "Set" },
  { value: "pack", label: "Pack" }, { value: "box", label: "Box" },
  { value: "carton", label: "Carton" }, { value: "roll", label: "Roll" },
  { value: "sheet", label: "Sheet" }, { value: "lot", label: "Lot" },
  { value: "unit", label: "Unit" }, { value: "bundle", label: "Bundle" },
  { value: "bag", label: "Bag" }, { value: "tin", label: "Tin" },
  { value: "bottle", label: "Bottle" }, { value: "can", label: "Can" },
  { value: "coil", label: "Coil" }, { value: "reel", label: "Reel" },
  // Mass
  { value: "mg", label: "Milligram (mg)" }, { value: "g", label: "Gram (g)" },
  { value: "kg", label: "Kilogram (kg)" }, { value: "quintal", label: "Quintal (q)" },
  { value: "MT", label: "Metric Tonne (MT)" }, { value: "oz", label: "Ounce (oz)" },
  { value: "lb", label: "Pound (lb)" },
  // Volume (liquid)
  { value: "uL", label: "Microlitre (µL)" }, { value: "mL", label: "Millilitre (mL)" },
  { value: "cL", label: "Centilitre (cL)" }, { value: "dL", label: "Decilitre (dL)" },
  { value: "L", label: "Litre (L)" }, { value: "kL", label: "Kilolitre (kL)" },
  { value: "m3", label: "Cubic Metre (m³)" }, { value: "cm3", label: "Cubic cm (cc)" },
  { value: "gal_us", label: "US Gallon" }, { value: "gal_uk", label: "UK Gallon" },
  // Length
  { value: "mm", label: "Millimetre (mm)" }, { value: "cm", label: "Centimetre (cm)" },
  { value: "m", label: "Metre (m)" }, { value: "km", label: "Kilometre (km)" },
  { value: "in", label: "Inch (in)" }, { value: "ft", label: "Foot (ft)" },
  { value: "yd", label: "Yard (yd)" }, { value: "mile", label: "Mile" },
  // Area
  { value: "cm2", label: "Sq Centimetre (cm²)" }, { value: "m2", label: "Sq Metre (m²)" },
  { value: "ft2", label: "Sq Foot (ft²)" }, { value: "acre", label: "Acre" },
  { value: "hectare", label: "Hectare (ha)" },
  // Time
  { value: "s", label: "Second (s)" }, { value: "min", label: "Minute (min)" },
  { value: "h", label: "Hour (h)" }, { value: "hr", label: "Hour (hr)" },
  { value: "day", label: "Day" }, { value: "wk", label: "Week (wk)" },
  { value: "month", label: "Month" }, { value: "quarter", label: "Quarter" },
  { value: "year", label: "Year (yr)" },
  // Energy / Power
  { value: "W", label: "Watt (W)" }, { value: "kW", label: "Kilowatt (kW)" },
  { value: "MW", label: "Megawatt (MW)" }, { value: "kVA", label: "kVA" },
  { value: "VA", label: "VA" }, { value: "MVA", label: "MVA" },
  { value: "J", label: "Joule (J)" }, { value: "kJ", label: "Kilojoule (kJ)" },
  { value: "Wh", label: "Watt-hour (Wh)" }, { value: "kWh", label: "Kilowatt-hour (kWh)" },
  { value: "MWh", label: "Megawatt-hour (MWh)" },
  { value: "cal", label: "Calorie (cal)" }, { value: "kcal", label: "Kilocalorie (kcal)" },
  { value: "BTU", label: "BTU" }, { value: "TR", label: "Ton of Refrigeration" },
  // Electrical
  { value: "V", label: "Volt (V)" }, { value: "kV", label: "Kilovolt (kV)" },
  { value: "A", label: "Ampere (A)" }, { value: "mA", label: "Milliampere (mA)" },
  { value: "Ohm", label: "Ohm (Ω)" }, { value: "Hz", label: "Hertz (Hz)" },
  { value: "Ah", label: "Ampere-hour (Ah)" },
  // Pressure / Temperature
  { value: "Pa", label: "Pascal (Pa)" }, { value: "kPa", label: "Kilopascal (kPa)" },
  { value: "bar", label: "Bar" }, { value: "psi", label: "psi" },
  { value: "atm", label: "Atmosphere (atm)" },
  { value: "Cel", label: "Celsius (°C)" }, { value: "K", label: "Kelvin (K)" },
  // Business
  { value: "hour", label: "Hour (person-hour)" }, { value: "days", label: "Days (person-days)" },
  { value: "trip", label: "Trip" }, { value: "visit", label: "Visit" },
  { value: "job", label: "Job" }, { value: "license", label: "License" },
  { value: "subscription", label: "Subscription" }, { value: "session", label: "Session" },
  { value: "kg_km", label: "Kg-Km (freight)" }, { value: "ton_km", label: "Ton-Km" },
];
